export default __webpack_public_path__ + "static/media/react-skill-icon.21a0c19c.svg";